import { useRef } from 'react';

interface ScrollToElementArgs extends ScrollIntoViewOptions {}

export const useScrollToElement = <T extends HTMLElement>({
    behavior = 'smooth',
    block = 'start',
    inline,
}: ScrollToElementArgs) => {
    const ref = useRef<T>(null);

    const scrollToElement = () =>
        ref?.current?.scrollIntoView({
            behavior,
            block,
            inline,
        });

    return {
        ref,
        scrollToElement,
    };
};
